import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import store from '../store';

/* eslint-disable */
const ApiService = {
    init() {
        Vue.use(VueAxios, axios);
        this.setHeader();
    },

    setHeader(idToken) {
        if (idToken) {
            Vue.axios.defaults.headers.common.Authorization = idToken;
        } else {
            Vue.axios.defaults.headers.common.Authorization = store.state.auth.idToken;
        }
    },

    query(resource, params) {
        return Vue.axios
            .get(resource, params)
            .catch((error) => {
                console.log(`[CRX] ApiService query ${error}`);
                throw new Error(`[CRX] ApiService ${error}`);
            });
    },

    get(resource, slug = '') {
        return Vue.axios
            .get(`${resource}/${slug}`)
            .catch((error) => {
                console.log(`[CRX] ApiService get ${error}`);
                throw new Error(`[CRX] ApiService ${error}`);
            });
    },

    post(resource, params, config) {
        return Vue.axios.post(`${resource}`, params, config)
            .catch((error) => {
                console.log(`[CRX] ApiService post ${error}`);
                throw new Error(`[CRX] ApiService ${error}`);
            });
    },

    update(resource, slug, params) {
        return Vue.axios.put(`${resource}/${slug}`, params)
            .catch((error) => {
                console.log(`[CRX] ApiService update ${error}`);
                throw new Error(`[CRX] ApiService ${error}`);
            });
    },

    put(resource, params) {
        return Vue.axios
            .put(`${resource}`, params)
            .catch((error) => {
                console.log(`[CRX] ApiService put ${error}`);
                throw new Error(`[CRX] ApiService ${error}`);
            });
    },

    delete(resource) {
        return Vue.axios
            .delete(resource)
            .catch((error) => {
                console.log(`[CRX] ApiService delete ${error}`);
                throw new Error(`[CRX] ApiService ${error}`);
            });
    }
};

export default ApiService;



// WEBPACK FOOTER //
// ./src/services/api.service.js